function splitArrayIntoChunks(array, chunkLength) {
  const chunks = [];
  let index = 0;

  while (index < array.length) {
    chunks.push(array.slice(index, index + chunkLength));
    index += chunkLength;
  }

  return chunks;
}

export default splitArrayIntoChunks;
